import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { useNavigate } from "react-router-dom";

import "../../styles/visa-box.css";
import { elipsize } from "../../_helpers/utility-methods";


export const VisaTypeBox = ({boxColor, boxIcon, caption, text}) => {

    const navigateTo = useNavigate();

    return (
        <div className="v-t-container" onClick={() => navigateTo("/visa-programs",{
            state: {
                subject: caption
            }
        })}>
            <div className="type-icon-box">
                <div 
                    className="icon-box"
                    style={{backgroundColor: boxColor }}
                >
                    <FontAwesomeIcon icon={boxIcon} />
                </div>
            </div>
            <div className="v-t-caption">
               <a href="##">{caption}</a> 
            </div>
            <div className="v-t-desc">{elipsize(text)}</div>
        </div>
    )
}